export default {
  SET_ACTIVITY_LOGS(state, data) { state.activityLogs = data; },
  SET_ACTIVITY_HABITS(state, data) { state.activityHabits = data; },
  SET_SELECT_DAY(state, data) { state.selectedDay = data; },
  ADD_HABIT_LOG(state, data) {
    const habitObject = state.habitsWithLogs.find((habit) => habit.localId === data.habitLocalId);
    habitObject.logs.push(data);
    state.activityLogs.push(data);
  },
  REMOVE_HABIT_LOG(state, data) {
    const habitObject = state.habitsWithLogs.find((habit) => habit.localId === data.habitLocalId);
    habitObject.logs = habitObject.logs.filter((log) => data.localId !== log.localId);
    state.activityLogs = state.activityLogs.filter((log) => data.localId !== log.localId);
  },
  SET_GROUPS_OF_HABITS(state, data) {
    state.groupsOfHabits = data;
  },
  CREATE_NEW_GROUP(state, data) {
    state.groupsOfHabits.push(data);
  },
  REMOVE_GROUP(state, data) {
    state.groupsOfHabits = state.groupsOfHabits.filter((group) => group.id !== data.id);
  },
};
